export const getMergedProductMachineData = (product, pageBuilderProductProps, pageBuilderProps) => {
    const { strikethrough_price, variant = {} } = pageBuilderProductProps
    const { ratingsAndReviews } = product

    // lists header props not coming from this.props
    const options = {
        ratings: ratingsAndReviews
    }

    if (variant?.colors) {
        options.colors = variant.colors
        options.activeSku = product.internationalId
        options.max_colors = 99
    }

    options.strikethrough_price = strikethrough_price || ''
    options.show_ratings = (pageBuilderProps && pageBuilderProps.options.show_ratings) || false
    options.minimum_rating = (pageBuilderProps && pageBuilderProps.options.minimum_rating) || 0

    return options
}
